<template>
    <page>
		<module>
			<module-column width="210" scroll>
				<div class="classify">
					<c-tree ref="tree" :load="loadClassifyTree" @node-click="classifySelect"></c-tree>
				</div>
			</module-column>
			
			<module-column enable-flex>
				<m-operate>
					<c-button color="sys" icon="add" @click="editItem()">新增定制项目</c-button>
				</m-operate>
				
				<c-table ref="itemTable" :paging="false">
					<c-table-column
						label="定制项名称"
						name="item_name"
						width="100"
					>
            <template v-slot="{data}">
              <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.item_name}}</span>
              <span v-if="data.is_edit == 1">{{data.item_name}}</span>
            </template>
          </c-table-column>
				
					<c-table-column
						label="是否显示"
						name="is_display"
						width="60"
					>
						<template v-slot="{data}">
							<span v-if="data.is_display == 0 && data.is_edit == 1" style="color:red">隐藏</span>
							<span v-if="data.is_display == 1 && data.is_edit == 1" style="color:green">显示</span>
							<span v-if="data.is_display == 0 && data.is_edit != 1" style="color:darkgrey">隐藏</span>
							<span v-if="data.is_display == 1 && data.is_edit != 1" style="color:darkgrey">显示</span>
						</template>
					</c-table-column>
				
					<c-table-column
						label="所属类目"
						name="product_type_full_name"
						width="180"
					>
            <template v-slot="{data}">
              <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.product_type_full_name}}</span>
              <span v-if="data.is_edit == 1">{{data.product_type_full_name}}</span>
            </template>
          </c-table-column>
				
					<c-table-column
						label="备注"
						name="remark"
						width="200"
					>
            <template v-slot="{data}">
              <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.remark}}</span>
              <span v-if="data.is_edit == 1">{{data.remark}}</span>
            </template>
          </c-table-column>
				
					<c-table-column
						type="button"
						label="操作"
						width="150"
					>
						<template v-slot="row">
							<c-table-button power="b_product_type_custom_config" @click="configParams(row.data)">配置参数</c-table-button>
							<c-table-button power="b_product_type_custom_config" v-if="row.data.is_edit == 1" @click="editItem(row.data)">编辑</c-table-button>
							<c-table-button power="b_product_type_custom_config" v-if="row.data.is_edit == 1 && row.data.is_display == 0" @click="updateItemState(row.data)">显示</c-table-button>
              <c-table-button power="b_product_type_custom_config" v-if="row.data.is_edit == 1 && row.data.is_display == 1" @click="updateItemState(row.data)">隐藏</c-table-button>
              <c-table-button power="b_product_type_custom_config" v-if="row.data.is_edit == 1 && row.data.is_display == 0" @click="delItem(row.data)">删除</c-table-button>
            </template>
					</c-table-column>
				</c-table>
				
				<c-dialog ref="itemEditDialog" :title="itemEditState ? '编辑定制项' : '新增定制项'" width="600" @resolve="editItemHandle">
					<c-form ref="itemEditForm">
						<c-form-item type="hidden" name="item_id"></c-form-item>
						<c-form-item type="input" label="定制项名称" name="item_name" required></c-form-item>
						<c-form-item type="radio" label="显示状态" name="is_display" :options="itemDisplayState" required></c-form-item>
						<c-form-item type="textarea" label="备注" name="remark"></c-form-item>
					</c-form>
				</c-dialog>
				
				<c-dialog ref="logoDialog" :title="`配置参数【${configItemData.item_name}】`" width="1000" :button="false">
					<module style="height: 550px;">
						<module-tab title="定制位置" enable-flex>
							<m-operate>
								<c-button color="sys" icon="add" @click="editParam({type: 1})">新增定制位置</c-button>
							</m-operate>
							<c-table ref="positionTable" :paging="false">
								<c-table-column
									  label="位置名称"
									  name="name"
								>
                  <template v-slot="{data}">
                    <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.name}}</span>
                    <span v-if="data.is_edit == 1">{{data.name}}</span>
                  </template>
                </c-table-column>
					
								<c-table-column
									label="位置图片"
									name="image_url"
								>
									<template v-slot="{data}">
										<div class="flex-center-cross">
											<c-image v-if="data.is_edit == 1" class="img" :src="data.img_url" size="50" preview></c-image>
											<c-image v-if="data.is_edit != 1" style="color:darkgrey" class="img" :src="data.img_url" size="50" preview></c-image>
										</div>
									</template>
								</c-table-column>
					
								<c-table-column
									label="备注"
									name="remark"
								>
                  <template v-slot="{data}">
                    <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.remark}}</span>
                    <span v-if="data.is_edit == 1">{{data.remark}}</span>
                  </template>
                </c-table-column>

                <c-table-column
                    label="所属类目"
                    name="product_type_full_name"
                    width="180"
                >
                  <template v-slot="{data}">
                    <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.product_type_full_name}}</span>
                    <span v-if="data.is_edit == 1">{{data.product_type_full_name}}</span>
                  </template>
                </c-table-column>

								<c-table-column
									label="创建时间"
									name="create_date"
									width="130"
								>
                  <template v-slot="{data}">
                    <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.create_date}}</span>
                    <span v-if="data.is_edit == 1">{{data.create_date}}</span>
                  </template>
                </c-table-column>
					
								<c-table-column
									type="button"
									label="操作"
									width="110"
								>
									<template v-slot="{data}">
										<c-table-button power="b_product_type_custom_config" v-if="data.is_edit == 1" @click="editParam(data)">编辑</c-table-button>
										<c-table-button power="b_product_type_custom_config" v-if="data.is_edit == 1" @click="delParam(data)">删除</c-table-button>
									</template>
								</c-table-column>
							</c-table>
						</module-tab>
						<module-tab title="定制工艺" enable-flex>
							<m-operate>
								<c-button color="sys" icon="add" @click="editParam({type: 2})">新增定制工艺</c-button>
							</m-operate>
							<c-table ref="techTable" :paging="false">
								<c-table-column
									label="工艺名称"
									name="name"
								>
                  <template v-slot="{data}">
                    <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.name}}</span>
                    <span v-if="data.is_edit == 1">{{data.name}}</span>
                  </template>
                </c-table-column>

                <c-table-column
                    label="所属类目"
                    name="product_type_full_name"
                    width="180"
                >
                  <template v-slot="{data}">
                    <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.product_type_full_name}}</span>
                    <span v-if="data.is_edit == 1">{{data.product_type_full_name}}</span>
                  </template>
                </c-table-column>

								<c-table-column
									label="备注"
									name="remark"
									width="130"
								>
                  <template v-slot="{data}">
                    <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.remark}}</span>
                    <span v-if="data.is_edit == 1">{{data.remark}}</span>
                  </template>
                </c-table-column>
					
								<c-table-column
									label="创建时间"
									name="create_date"
									width="130"
								>
                  <template v-slot="{data}">
                    <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.create_date}}</span>
                    <span v-if="data.is_edit == 1">{{data.create_date}}</span>
                  </template>
                </c-table-column>
					
								<c-table-column
									type="button"
									label="操作"
									width="110"
								>
									<template v-slot="{data}">
										<c-table-button power="b_product_type_custom_config" v-if="data.is_edit == 1" @click="editParam(data)">编辑</c-table-button>
										<c-table-button power="b_product_type_custom_config" v-if="data.is_edit == 1" @click="delParam(data)">删除</c-table-button>
									</template>
								</c-table-column>
							</c-table>
						</module-tab>
					</module>
				</c-dialog>
				
				<c-dialog ref="paramDialog" :title="`配置参数【${configItemData.item_name}】`" width="1000" :button="false">
					<module enable-flex style="height: 550px;">
						<m-operate>
							<c-button color="sys" icon="add" @click="editParam({type: 3})">新增参数</c-button>
						</m-operate>
					
						<c-table ref="paramTable" :paging="false">
							<c-table-column
								label="参数名称"
								name="name"
								width="130"
							>
								<template v-slot="{data}">
                  <span v-if="data.is_edit == 1">
                    {{data.name}}<span v-if="configItemData.item_type == 3 && data.code">（{{data.code}}）</span>
                  </span>
                  <span v-if="data.is_edit != 1" style="color:darkgrey">
                    {{data.name}}<span v-if="configItemData.item_type == 3 && data.code">（{{data.code}}）</span>
                  </span>
								</template>
							</c-table-column>

              <c-table-column
                  label="所属类目"
                  name="product_type_full_name"
                  width="180"
              >
                <template v-slot="{data}">
                  <span v-if="data.is_edit == 1">{{data.product_type_full_name}}</span>
                  <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.product_type_full_name}}</span>
                </template>

              </c-table-column>

							<c-table-column
								label="备注"
								name="remark"
								width="130"
							>
                <template v-slot="{data}">
                  <span v-if="data.is_edit == 1">{{data.remark}}</span>
                  <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.remark}}</span>
                </template>

              </c-table-column>
						
							<c-table-column
								label="创建时间"
								name="create_date"
								width="130"
							>
                <template v-slot="{data}">
                  <span v-if="data.is_edit == 1">{{data.create_date}}</span>
                  <span v-if="data.is_edit != 1" style="color:darkgrey">{{data.create_date}}</span>
                </template>
              </c-table-column>
						
							<c-table-column
								type="button"
								label="操作"
								width="110"
							>
							  <template v-slot="{data}">
								<c-table-button power="b_product_type_custom_config" v-if="data.is_edit == 1" @click="editParam(data)">编辑</c-table-button>
								<c-table-button power="b_product_type_custom_config" v-if="data.is_edit == 1" @click="delParam(data)">删除</c-table-button>
							  </template>
							</c-table-column>
						</c-table>
					</module>
				</c-dialog>
				
				<c-dialog ref="paramEditDialog" :title="(paramEditState ? '编辑' : '新增') + editParamData.title" width="600" @resolve="editParamHandle">
					<c-form ref="paramEditForm">
						<c-form-item type="hidden" name="id"></c-form-item>
						<c-form-item type="hidden" name="type"></c-form-item>
						<c-form-item type="input" :label="`${editParamData.title || ''}名称`" name="name" required></c-form-item>
						<c-form-item v-show="editParamData.type == 1" type="image" label="位置示意图" name="img_url" required></c-form-item>
						<c-form-item v-show="configItemData.item_type == 3" type="color" label="颜色色值" name="code" required></c-form-item>
						<c-form-item type="textarea" label="备注" name="remark"></c-form-item>
					</c-form>
				</c-dialog>
			</module-column>
		</module>
	</page>
</template>

<script>
	import cTree from '@/components/unit/tree.vue'
	
	export default {
		name: 'm_product_custom',
		
		components: {
			cTree
		},
		
		data() {
			return {
				itemDisplayState: [{
					name: '隐藏',
					value: 0
				}, {
					name: '显示',
					value: 1
				}],
				itemEditState: false,
				configItemData: {},
				paramEditState: false,
				editParamData: {}
			}
		},
		
		methods: {
			loadClassifyTree(node, resolve) {
				if (!node) {
					this.$nextTick(() => {
						resolve([{
							name: '全部类目',
							id: 0
						}]);
						
						this.$nextTick(() => {
							this.$refs.tree.getNode()[0].expand();
						});
					});
					return;
				}
				
				this.request({
					url: '/product_type/list',
					data: {
						parent_id: node ? node.data.id : 0
					},
					success: data => {
						data.forEach(item => {
							item.name = item.type_name;
							item.value = item.id;
							item.leaf = item.child_count == 0;
						})
						resolve(data || []);
					}
				});
			},
			
			classifySelect(node) {
				this._classifyId = node.data.id;
				this.$refs.itemTable.load({
					url: '/custom/item/list',
					data: {
						product_type_id: node.data.id
					}
				});
			},
			
			editItem(data) {
				if (this._classifyId === undefined) {
					this.$message({
						text: '请选择类目'
					});
					return;
				}
				this.itemEditState = !!data;
				this.$refs.itemEditForm.clear();
				this.$refs.itemEditForm.set(data || {
					is_display: 0
				});
				this.$refs.itemEditDialog.open();
			},
			
			editItemHandle(stop) {
				stop();
				this.$refs.itemEditForm.submit({
					url: this.itemEditState ? '/custom/item/edit' : '/custom/item/add',
					rule: {
						item_name: '请填写定制项名称'
					},
					dataFormatter: data => {
						data.product_type_id = this._classifyId;
						data.id = data.item_id;
						delete data.item_id;
						return data;
					},
					success: (data, res) => {
						this.$message({
							text: '保存成功'
						});
						this.$refs.itemTable.update();
						this.$refs.itemEditDialog.close();
					}
				});
			},
			
			updateItemState(data) {
				this.$confirm({
					text: '确定要' + (data.is_display == 0 ? '显示' : '隐藏') + '【' + data.item_name + '】吗？',
					resolve: () => {
						this.request({
							url: '/custom/item/change/state',
							data: {
								id: data.item_id
							},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.itemTable.update();
							}
						});
					}
				});
			},
			
			delItem(data) {
				this.$confirm({
					text: '确定要删除定制项【' + data.item_name + '】？',
					resolve: () => {
						this.request({
							url: '/custom/item/remove',
							data: {
								id: data.item_id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功',
									icon: 'success'
								});
								this.$refs.itemTable.update();
							}
						});
					}
				});
			},
			
			configParams(data) {
				this.configItemData = data;
				if (data.item_type == 1) {
					this.$refs.logoDialog.open();
					this.$refs.positionTable.load({
						url: '/custom/item/param/list',
						data: {
							type: 1,
							product_type_id: this._classifyId,
							item_id: data.item_id
						}
					});
					this.$refs.techTable.load({
						url: '/custom/item/param/list',
						data: {
							type: 2,
							product_type_id: this._classifyId,
							item_id: data.item_id
						}
					});
				} else {
					this.$refs.paramDialog.open();
					this.$refs.paramTable.load({
						url: '/custom/item/param/list',
						data: {
							type: 3,
							product_type_id: this._classifyId,
							item_id: data.item_id
						}
					});
				}
			},
			
			editParam(data) {
				this.paramEditState = !!data.id;
				this.editParamData = data;
				if (data.type == 1) {
					this.editParamData.title = '位置';
				} else if (data.type == 2) {
					this.editParamData.title = '工艺';
				} else if (data.type == 3) {
					if (this.configItemData.item_type == 3) {
						this.editParamData.title = '颜色';
					} else {
						this.editParamData.title = '参数';
					}
				}
				this.$refs.paramEditForm.clear();
				this.$refs.paramEditForm.set(data);
				this.$refs.paramEditDialog.open();
			},
			
			delParam(data) {
				this.$confirm({
					text: '确定要删除【' + data.name + '】？',
					resolve: () => {
						this.request({
							url: '/custom/item/param/remove',
							data: {
								id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
								if (data.type == 1) {
									this.$refs.positionTable.update();
								}
								if (data.type == 2) {
									this.$refs.techTable.update();
								}
								if (data.type == 3) {
									this.$refs.paramTable.update();
								}
							}
						});
					}
				});
			},
			
			editParamHandle(stop) {
				stop();
				this.$refs.paramEditForm.submit({
					url: this.paramEditState ? '/custom/item/param/edit' : '/custom/item/param/add',
					rule: {
						name: `${this.editParamData.title || ''}名称`,
						img_url: [{
							type: 'empty',
							skip: () => {
								return this.editParamData.type != 1;
							},
							word: '请上传位置示意图'
						}],
						code: [{
							type: 'empty',
							skip: () => {
								return this.configItemData.item_type != 3;
							},
							word: '请选择颜色色值'
						}]
					},
					dataFormatter: data => {
						data.item_id = this.configItemData.item_id;
						data.type = this.editParamData.type;
						data.product_type_id = this._classifyId;
						return data;
					},
					success: (data, res) => {
						this.$message({
							text: '保存成功'
						});
						if (this.editParamData.type == 1) {
							this.$refs.positionTable.update();
						}
						if (this.editParamData.type == 2) {
							this.$refs.techTable.update();
						}
						if (this.editParamData.type == 3) {
							this.$refs.paramTable.update();
						}
						this.$refs.paramEditDialog.close();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.classify {
		min-height: 100%;
		background: #F9FAFC;
	}
</style>